import React, { useState } from 'react'
import { addMonths, startOfMonth } from 'date-fns'
import { Button } from '../../../common/Button'
import { formatDateWithFormat } from '../../../../helpers/date'
import { capitalize } from '../../../../helpers/string'
import { theme } from '../../../../theme/theme'
import { Icon, IconChoices } from '../../../common/Icon'
import { FacilityBookingsList } from '../FacilityBookingsList'
import { Divider } from '../../../common/Divider'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { useIsMobile } from '../../../../hooks/useIsMobile'
import { IFacilityModel } from '../../../../interfaces/models/facilities.interfaces'

interface FacilityBookingsProps {
  facility: IFacilityModel
}

export const FacilityBookings = ({
  facility,
}: FacilityBookingsProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const isMobile = useIsMobile()
  const [selectedStartOfMonthDate, setSelectedStartOfMonthDate] = useState(
    startOfMonth(new Date())
  )

  const addMonthsToSelected = (months: number): void => {
    setSelectedStartOfMonthDate(
      startOfMonth(addMonths(selectedStartOfMonthDate, months))
    )
  }

  return (
    <div className="w-full">
      <div className="mb-6 flex items-center justify-between">
        {isMobile ? (
          <button onClick={() => addMonthsToSelected(-1)} className="md:hidden">
            <Icon icon={IconChoices.ARROW_LEFT} />
          </button>
        ) : (
          <Button
            label={translate('facilityView.bookings.buttons.previousMonth')}
            icon={IconChoices.ARROW_LEFT}
            onClick={() => addMonthsToSelected(-1)}
          />
        )}
        <p style={theme.textVariants.lead}>
          {capitalize(
            formatDateWithFormat(selectedStartOfMonthDate, 'MMMM yyyy')
          )}
        </p>
        {isMobile ? (
          <button onClick={() => addMonthsToSelected(1)} className="md:hidden">
            <Icon icon={IconChoices.ARROW_RIGHT} />
          </button>
        ) : (
          <Button
            label={translate('facilityView.bookings.buttons.nextMonth')}
            icon={IconChoices.ARROW_RIGHT}
            iconPlacement="right"
            onClick={() => addMonthsToSelected(1)}
          />
        )}
      </div>
      <Divider />
      <FacilityBookingsList
        facility={facility}
        startOfMonthDate={selectedStartOfMonthDate}
      />
    </div>
  )
}
